import FinishedAllCampaignsMessage from './FinishedAllCampaignsMessage';
import './FinishedAllCampaignsMessage.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


// Actions
import {
  finishAllCampaignsEvent,
  shareSocialMediaEvent
} from '../../../../redux/mixpanel/actions';

// Redux
const mapStateToProps = (state) => {
  return {};
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    finishAllCampaignsEvent,
    shareSocialMediaEvent
  }, dispatch);
}

const ConnectedFinishedAllCampaignsMessage = connect(
  mapStateToProps,
  mapDispatchToProps
)(FinishedAllCampaignsMessage);

export default ConnectedFinishedAllCampaignsMessage;



// WEBPACK FOOTER //
// ./src/pages/Campaigns/components/FinishedAllCampaignsMessage/index.js